import { generateGoogleReCaptchaHiddenBadgeStyles as t } from "./generateGoogleReCaptchaHiddenBadgeStyles.js";
const d = () => {
  const e = document.createElement("style");
  e.innerHTML = t(), document.body.appendChild(e);
};
export {
  d as hideGoogleReCaptchaBadge
};
//# sourceMappingURL=hideGoogleReCaptchaBadge.js.map
